<div class="ap-header">
    <div class="ap-header-text">
        <h4 class="ap-header-title">{{ section.title }}</h4>
        <p class="ap-header-subtitle" *ngIf="section.subtitle">{{ section.subtitle }}</p>
    </div>
    <app-simple-badge
        *ngIf="section.statusChip"
        [color]="section.statusChip.tone || 'default'"
        [label]="section.statusChip.label">
    </app-simple-badge>
</div>
